import { errorHandler } from '../lib/errorHandler'

const fetchData = function(url) {
  const headers = new Headers()
  headers.set('Accept', 'application/json')
  return fetch(`${url}`, {
    method: 'GET',
    headers,
    credentials: 'include',
  })
    .then(errorHandler)
    .then(res => {
      return { daneGUSArr: res }
    })
    .catch(() => {
      return { daneGUSArr: [], error: true }
    })
}

const usunSeparatory = function(value) {
  if (value) {
    var result = value.replace(/-/gi, '')
    if (result) result = result.replace(/ /gi, '')
    if (result) return result.toUpperCase()
  }
  return ''
}

const getData = function(url, czyPobracPKD) {
    return fetchData(`${url}`).then(data => {
      const { daneGUSArr, error } = data
      if (!daneGUSArr || daneGUSArr.length === 0)
        return new Promise(resolve => {
          resolve({ daneGUS: null, danePKD: null, gusServerError: error })
        })

      const [daneGUS] = daneGUSArr
      if (!daneGUS)
        return new Promise(resolve => {
          resolve({ daneGUS: null, danePKD: null })
        })
      if (!czyPobracPKD)
        return new Promise(resolve => {
          resolve({ daneGUS, danePKD: null })
        })

      if (daneGUS.Rejestr.ZakonczonaDzialalnosc)
        return new Promise(resolve => {
          resolve({ daneGUS, danePKD: {} })
        })

      url = '/wyszukajdzialalnoscipkd?NIP=' + daneGUS.NIP
      return fetchData(`${url}`).then(data => {
        const { daneGUSArr, error } = data
        if (!daneGUSArr || daneGUSArr.length === 0)
          return new Promise(resolve => {
            resolve({
              daneGUS,
              danePKD: null,
              gusServerError: error,
            })
          })

        const [danePKD] = daneGUSArr
        if (!danePKD)
          return new Promise(resolve => {
            resolve({ daneGUS, danePKD: null })
          })
        return new Promise(resolve => {
          resolve({ daneGUS, danePKD })
        })
      })    
  })
}

const znajdzWgNIP = function(nip, czyPobracPKD) {
  return getData(
    '/wyszukajwielunip?NIP=' + usunSeparatory(nip),
    czyPobracPKD,
  )
}

const znajdzWgKRS = function(krs) {
  return getData(
    '/wyszukajwielukrs?KRS=' + usunSeparatory(krs),
    true,
  )
}

export { znajdzWgNIP, znajdzWgKRS }
